module.exports = __webpack_public_path__ + "img/cooperationAdvantagesImg3.66c70b37.png";